import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  FormControlLabel,
  ListItem,
  styled
} from "@mui/material"

export const StyleAccordion = styled(Accordion)({
  borderBottom: "none",
  width: "100%"
})
export const StyleAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  padding: `0 0 0 ${theme.spacing(2)}`,
  margin: 0,
  "& > .MuiAccordionSummary-content": {
    margin: "0!important",
    minHeight: "0!important",
    "&.Mui-expanded": {
      margin: "0!important"
    }
  },
  "&.Mui-expanded": {
    margin: "0!important",
    minHeight: "48px!important"
  }
}))

export const StyleSubListItem = styled(ListItem)({
  padding: "0 8px 0 30px"
})

export const StyleAccordionDetails = styled(AccordionDetails)({
  padding: 0,
  margin: 0
})

export const StyledFormControlLabelBold = styled(FormControlLabel)({
  "& .MuiFormControlLabel-label": {
    fontWeight: "600"
  }
})

export const StyledListItemWrapper = styled(ListItem)(({ theme }) => ({
  padding: 0,
  width: "100%",
  gap: theme.spacing(1),
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start"
}))

export const StyledBoxWrapper = styled(Box)(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  flexWrap: "wrap",
  gap: theme.spacing(1),
  paddingBottom: theme.spacing(1)
}))
